module.exports = __webpack_public_path__ + "static/media/ellipsis-h-alt.1e71793d.svg";